import { render, staticRenderFns } from "./OwnerNoticeList.vue?vue&type=template&id=35a98d70&"
import script from "./OwnerNoticeList.vue?vue&type=script&lang=js&"
export * from "./OwnerNoticeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports